import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ProgramService } from '../../services/program.service';
import { Program } from '../../interfaces/program.model';
import { SubProgram } from '../../interfaces/sub-program.model';
import { Target } from '../../interfaces/target.model';
import { TreeListItem } from '../../interfaces/tree-list-item.model';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { NavBarService } from '../../services/nav-bar.service';

@Component({
  selector: 'app-program-detail',
  templateUrl: './program-detail.component.html',
  styleUrls: ['./program-detail.component.scss'],
})
export class ProgramDetailComponent implements OnInit {
  program: Program = <Program>{
    id: 0,
    number: 0,
    name: null,
    estimated: 0,
    realised: 0,
    forecast: 0,
    space: 0,
  };
  targets: TreeListItem[] = [];
  NavBarData: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProgramService,
    private NavBarService: NavBarService
  ) {}

  ngOnInit() {
    this.route.params
      .switchMap((params: Params) => this.service.getProgram(+params['id']))
      .subscribe(a => {
        this.program = <Program>{
          id: a.id,
          number: a.Weergavenummer,
          name: a.naam,
          text: a.omschrijving,
          estimated: a.begroot,
          realised: a.gerealiseerd,
          forecast: a.prognose,
          space: a.ruimte,
          red: a.red,
          green: a.green,
          orange: a.orange,
          imageUrl: a.ImageUrl,
          costs: {
            total: a.lasten_actueel,
            realised: a.lasten_besteed,
            space: a.saldo_besteed,
            forecast: a.lasten_prognose,
          },
        };

        this.NavBarData = this.NavBarService.getData().getValue();

        this.NavBarData = {
          title: `${a.Weergavenummer}. ${a.naam}`,
          color: a.Weergavenummer,
          crumbs: [
            // { text: 'Programma', link: '/' },
            {
              text: `${a.Weergavenummer}. ${a.naam}`,
              link: `/programma/${a.id}`,
              active: true,
            },
          ],
        };

        this.NavBarService.setData(this.NavBarData);

        this.route.params
          .switchMap((params: Params) => this.service.getTargets(+params['id']))
          .subscribe(t => {
            this.targets = t.map((b: SubProgram) => {
              return <TreeListItem>{
                text: `${this.program.number}.${b.number} ${b.name}`,
                subtext: b.text,
                children: b.targets.map((c: Target) => {
                  return <TreeListItem>{
                    text: `${c.number} ${c.name}`,
                    link: `/programma/${this.program.id}/beleidsdoel/${c.id}`,
                  };
                }),
              };
            });
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/program-detail/program-detail.component.ts